// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePoolUpdateBody = {
  poolId: string;
  name?: string;
  joinPolicy?: "open" | "approval";
  visibility?: "public" | "private";
  autoApprove?: boolean;
  memberSharingEnabled?: boolean;
  chatEnabled?: boolean;
  commissionerPreamble?: string | null;
  maxMembers?: number | null;
};

export type typePoolUpdateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    poolId: string;
    name: string;
    joinPolicy: "open" | "approval";
    visibility: "public" | "private";
    autoApprove: boolean;
    memberSharingEnabled: boolean;
    chatEnabled: boolean;
    commissionerPreamble?: string | null;
    maxMembers: number | null;
  };
};

export type typePoolUpdateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolUpdateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePoolUpdateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPoolUpdateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    name: { type: "string", maxLength: 3000, minLength: 1 },
    joinPolicy: { type: "string", enum: ["open", "approval"] },
    visibility: { type: "string", enum: ["public", "private"] },
    autoApprove: { type: "boolean" },
    memberSharingEnabled: { type: "boolean" },
    chatEnabled: { type: "boolean" },
    commissionerPreamble: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    maxMembers: { oneOf: [{ type: "integer" }, { enum: [null] }] },
  },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPoolUpdate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPoolUpdateBody);
  }

  return async function postPoolUpdate(
    payload: typePoolUpdateBody,
  ): Promise<typePoolUpdateOutput200 | typePoolUpdateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPoolUpdate" failed before calling the network. #2597619a1527`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#2597619a1527" },
        },
        data: null,
      } as typePoolUpdateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pool/update`,
      httpMethod: "POST",
      options,
    })) as typePoolUpdateOutput200 | typePoolUpdateOutput400;
  };
}
